import IrisGrid from '@deephaven/iris-grid';
import { LoadingOverlay } from '@deephaven/components';
import { getErrorMessage } from '@deephaven/utils';
import { PandasReloadButton } from "./panels/PandasReloadButton.js";
import { useIrisGridModel } from "./useIrisGridModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function PandasWidgetPlugin(_ref) {
  var fetch = _ref.fetch;
  var fetchResult = useIrisGridModel(fetch);
  if (fetchResult.status === 'loading') {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      isLoading: true,
      "data-testid": "pandas-widget-plugin-loading"
    });
  }
  if (fetchResult.status === 'error') {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      errorMessage: getErrorMessage(fetchResult.error),
      isLoading: false,
      "data-testid": "pandas-widget-plugin-loading-error"
    });
  }
  var model = fetchResult.model,
    reload = fetchResult.reload;
  return /*#__PURE__*/_jsx(IrisGrid, {
    model: model,
    children: /*#__PURE__*/_jsx(PandasReloadButton, {
      onClick: reload
    })
  });
}
export default PandasWidgetPlugin;
//# sourceMappingURL=PandasWidgetPlugin.js.map